import Icon from '../components/Icon.vue'

Icon.register({
  'volleyball-ball': {
    width: 495,
    height: 512,
    paths: [
      {
        d: 'M223.3 243.4C222.4 206.4 214.7 170.6 200.6 137.7 109.8 180.1 43.1 260.1 20.3 354.5 33.7 385.3 53.2 412.8 77.2 435.6 99.9 356.4 151.4 287.8 223.3 243.4zM186.4 109C171.4 82.6 151.9 58.9 129 38.3 38 88.1-15.8 191.2 4 300.5 37.4 217.4 102.4 148.5 186.4 109zM374 274.1C382.6 174.3 346.7 76.6 276.5 9.7 261.8 8 224.9 4.2 177.6 18.2 234.9 77.5 268.6 156.4 271.1 240.9 303.6 258.6 338.4 269.9 374 274.1zM249.3 283.6C217.7 302.9 190.6 327.5 169.1 356.2 251.1 413.5 353.6 431.3 446.6 404 466.3 377.6 480.8 347.2 488.8 314.1 462.2 320.7 435.1 324.5 407.9 324.5 353.3 324.4 299 310.4 249.3 283.6zM151 383.3C135.8 409.3 125.3 437.7 118.9 467.5 156.5 490.5 200.6 504 248 504 309 504 364.7 481.9 407.9 445.4 295 461.5 204.6 420.6 151 383.3zM331.3 22.7C386.6 93.1 413.8 183.9 405.9 276.3 436.2 276.5 466.4 271.5 495.6 262.1 495.6 260.1 495.9 258.1 495.9 256.1 495.9 148.3 427.2 57 331.3 22.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volleyball-ball.js
// module id = uWsJ
// module chunks = 144